/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { QuestLeaderboardProfile } from './QuestLeaderboardProfile';
import {
    QuestLeaderboardProfileFromJSON,
    QuestLeaderboardProfileFromJSONTyped,
    QuestLeaderboardProfileToJSON,
    QuestLeaderboardProfileToJSONTyped,
} from './QuestLeaderboardProfile';

/**
 * 
 * @export
 * @interface GetQuestLeaderboardsResponse
 */
export interface GetQuestLeaderboardsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetQuestLeaderboardsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<QuestLeaderboardProfile>}
     * @memberof GetQuestLeaderboardsResponse
     */
    leaderboards: Array<QuestLeaderboardProfile>;
}

/**
 * Check if a given object implements the GetQuestLeaderboardsResponse interface.
 */
export function instanceOfGetQuestLeaderboardsResponse(value: object): value is GetQuestLeaderboardsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('leaderboards' in value) || value['leaderboards'] === undefined) return false;
    return true;
}

export function GetQuestLeaderboardsResponseFromJSON(json: any): GetQuestLeaderboardsResponse {
    return GetQuestLeaderboardsResponseFromJSONTyped(json, false);
}

export function GetQuestLeaderboardsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetQuestLeaderboardsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'leaderboards': ((json['leaderboards'] as Array<any>).map(QuestLeaderboardProfileFromJSON)),
    };
}

export function GetQuestLeaderboardsResponseToJSON(json: any): GetQuestLeaderboardsResponse {
    return GetQuestLeaderboardsResponseToJSONTyped(json, false);
}

export function GetQuestLeaderboardsResponseToJSONTyped(value?: GetQuestLeaderboardsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'leaderboards': ((value['leaderboards'] as Array<any>).map(QuestLeaderboardProfileToJSON)),
    };
}

